import { request } from './core.api';

export type ReminderRecurrenceUnit = 'day' | 'month' | 'year';

export interface ReminderDto {
  id: string;
  propertyId?: string;
  propertyAddress?: string;
  documentId?: string;
  title: string;
  dueDate: string;
  isCompleted: boolean;
  recurrenceIntervalValue?: number;
  recurrenceUnit?: ReminderRecurrenceUnit;
  createdAt: string;
}

export interface CreateReminderRequest {
  propertyId?: string;
  documentId?: string;
  title: string;
  dueDate: string;
  recurrenceIntervalValue?: number;
  recurrenceUnit?: ReminderRecurrenceUnit;
}

export interface UpdateReminderRequest {
  title: string;
  dueDate: string;
  isCompleted: boolean;
  recurrenceIntervalValue?: number;
  recurrenceUnit?: ReminderRecurrenceUnit;
}

export const remindersApi = {
  getAll: () => request<ReminderDto[]>('/reminders'),
  getByProperty: (propertyId: string) => request<ReminderDto[]>(`/properties/${propertyId}/reminders`),
  getById: (id: string) => request<ReminderDto>(`/reminders/${id}`),
  create: (data: CreateReminderRequest) => request<ReminderDto>('/reminders', { method: 'POST', body: JSON.stringify(data) }),
  update: (id: string, data: UpdateReminderRequest) => request<ReminderDto>(`/reminders/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  delete: (id: string) => request<void>(`/reminders/${id}`, { method: 'DELETE' }),
};
